var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"work-cover"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"bg-wrap ani-fade-in"},[_vm._t("cover")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }